import React, { useEffect, useState } from "react";
import { Trash2, Plus } from "lucide-react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { AdminShell, SaveButton } from "@/components/admin/AdminShell";
import { Text, Area, ListArea } from "@/components/admin/Field";

export default function ApproachEditor() {
  const [d, setD] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get("/content/approach").then((r) => setD(r.data)).catch(() => {});
  }, []);

  const set = (k, v) => setD((p) => ({ ...p, [k]: v }));
  const setNode = (i, k, v) => setD((p) => { const nodes = [...p.nodes]; nodes[i] = { ...nodes[i], [k]: v }; return { ...p, nodes }; });
  const addNode = () => setD((p) => ({ ...p, nodes: [...p.nodes, { name: "New Link", note: "" }] }));
  const delNode = (i) => setD((p) => ({ ...p, nodes: p.nodes.filter((_, idx) => idx !== i) }));

  const save = async () => {
    setSaving(true);
    try {
      await api.put("/admin/content/approach", d);
      toast.success("Approach page updated");
    } catch (e) {
      toast.error("Could not save");
    } finally {
      setSaving(false);
    }
  };

  if (!d) return <AdminShell title="Our Approach"><div className="text-taupe">Loading…</div></AdminShell>;

  return (
    <AdminShell title="Our Approach" subtitle="Treat the Chain page content" actions={<SaveButton onClick={save} saving={saving} label="Publish Changes" />}>
      <div className="bg-ivory border border-espresso/10 rounded-md p-7 mb-6 grid md:grid-cols-2 gap-5">
        <Text label="Eyebrow" value={d.eyebrow} onChange={(v) => set("eyebrow", v)} />
        <Text label="Headline" value={d.headline} onChange={(v) => set("headline", v)} />
        <div className="md:col-span-2"><Area label="Intro" value={d.intro} onChange={(v) => set("intro", v)} rows={4} /></div>
        <div className="md:col-span-2"><ListArea label="Protocol Flow Steps" value={d.flow} onChange={(v) => set("flow", v)} help="e.g. Assess, Treat, Reassess…" /></div>
      </div>

      <div className="bg-ivory border border-espresso/10 rounded-md p-7">
        <div className="flex items-center justify-between mb-6">
          <h2 className="font-serif text-2xl text-espresso">Kinetic Chain Links</h2>
          <button onClick={addNode} className="flex items-center gap-2 text-xs uppercase tracking-[0.14em] text-espresso border border-espresso/20 rounded-full px-4 py-2 hover:bg-linen" data-testid="approach-add-node">
            <Plus size={14} /> Add Link
          </button>
        </div>
        <div className="space-y-4">
          {d.nodes.map((n, i) => (
            <div key={i} className="grid md:grid-cols-[200px_1fr_auto] gap-4 items-start border-t border-espresso/10 pt-4">
              <Text label={`Link ${i + 1}`} value={n.name} onChange={(v) => setNode(i, "name", v)} />
              <Area label="Note" value={n.note} onChange={(v) => setNode(i, "note", v)} rows={2} />
              <button onClick={() => delNode(i)} className="text-destructive/70 hover:text-destructive mt-8" data-testid={`approach-del-node-${i}`}><Trash2 size={18} /></button>
            </div>
          ))}
        </div>
      </div>

      <div className="flex justify-end mt-6"><SaveButton onClick={save} saving={saving} label="Publish Changes" /></div>
    </AdminShell>
  );
}
